export const colors = {
  PrimaryDarkAquaMarine: "var(--color-primary-dark-aquamarine)",
  Black: "var(--color-primary-black)",
  Grey96: "var(--color-medium-grey)",
  GreyE1: "var(--color-light-grey)",
  White: "var(--color-white)",
  DefaultBackground: "var(--color-default-background)",
  DupontBrandRed: "var(--color-red)",
};

export const fontStyles = {
  diodrum12: `
    font-family: Diodrum;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  `,
  diodrum14: `
    font-family: Diodrum;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  `,
};

export const checkBoxStyles = {
  defaultCheckBox: `
    border-radius: 2px;
    background-color: ${colors.White};
    box-shadow: none;
  `,
};
